import styled from 'styled-components';
import { width, widthEm, isPortrait } from '../../utils/size';

import { Body as DefaultBody, Description as DefaultDescription } from './Details';

const calculateTitleSize = (
    isPortrait,
    isShortText,
    isLongText,
    isExtraLongText,
    scaleFactor = 1
) => {
    const defaultSize = isShortText ? 32 : isExtraLongText ? 24 : isLongText ? 28 : 30;
    const widthRatio = Math.min(1, width() / (isPortrait ? 375 : 620));
    return defaultSize * scaleFactor * widthRatio;
};
const calculateDescriptionSize = (isPortrait, isLongText, isExtraLongText) => {
    const defaultSize = isExtraLongText ? 16 : isLongText ? 18 : 22;
    const widthRatio = Math.min(1, width() / (isPortrait ? 375 : 620));
    return defaultSize * widthRatio;
};

export const Title = styled.h2`
    font-family: Averta;
    font-weight: 300;
    margin: 0;
    word-break: break-word;

    font-size: ${props =>
        props.isVideoCard
            ? `22px`
            : calculateTitleSize(
                  isPortrait(),
                  props.isShortText,
                  props.isLongText,
                  props.isExtraLongText,
                  props.scaleFactor
              ) + 'px'};
    line-height: ${props =>
        props.isVideoCard
            ? `28px`
            : calculateTitleSize(
                  isPortrait(),
                  props.isShortText,
                  props.isLongText,
                  props.isExtraLongText,
                  props.scaleFactor
              ) +
              5 +
              'px'};

    span {
        font-weight: 800;
        color: #ff245e;
        cursor: pointer;
    }

    ${props =>
        props.isLocalRepLoading
            ? `
          background-image: linear-gradient(to left, #f8f8f7, #f3f3f0 50%, #f8f8f7);
          text-indent: -9999px;
          margin-bottom: 12px;
        `
            : ''};
`;

export const Description = styled(DefaultDescription)`
    font-size: ${props =>
        calculateDescriptionSize(isPortrait(), props.isLongText, props.isExtraLongText) +
        'px'};
    line-height: ${props =>
        calculateDescriptionSize(isPortrait(), props.isLongText, props.isExtraLongText) +
        5 +
        'px'};
    margin-top: ${props => (props.isTargetedMultiAction && isPortrait() ? `10px` : 0)};
    ${props => (props.isLocalRepLoading ? `text-indent: -9999px;` : '')};

    span {
        font-weight: 800;
        color: #ff245e;
        cursor: pointer;
    }

    &:before {
        ${props =>
            props.isLocalRepLoading
                ? `
          content: "";
          background-image: linear-gradient(to left, #f8f8f7, #f3f3f0 50%, #f8f8f7);
          width: 100%;
          height: 20px;
          margin-bottom: 8px;
          float: left;
        `
                : ''};
    }

    &:after {
        ${props =>
            props.isLocalRepLoading
                ? `
          content: "";
          background-image: linear-gradient(to left, #f8f8f7, #f3f3f0 50%, #f8f8f7);
          width: 80%;
          height: 20px;
          float: left;
        `
                : ''};
    }
`;

export const ActionContainer = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
    flex-direction: ${props =>
        props.isSingleAction && widthEm() < 30 ? `column` : `row`};
    margin-bottom: 40px;
    width: 100%;

    ${props =>
        widthEm() <= 30
            ? `
        margin-left: auto;
        flex-direction: column;
        ${props.isLocalRepCard}width: calc(100% - 60px - 1em)
      `
            : ``};

    button {
        ${props =>
            props.isLocalRepLoading
                ? `
          text-indent: -9999px;
          background-image: linear-gradient(to left, #f8f8f7, #f3f3f0 50%, #f8f8f7);
          border: none !important;
        `
                : ``};
    }
`;

export const Body = DefaultBody.extend`
    ${props =>
        props.isBlured
            ? `filter: blur(1px);   opacity: 0.8; background-color: rgba(255, 255, 255, 0.8);`
            : ``};
`;

export const PeopleSigned = styled.div`
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 2px;
    color: #c9c3c3;
    font-weight: bold;
    margin-top: 10px;
`;

export const Content = styled.div`
    display: flex;
    ${props => (props.isVideoCard || props.isSentimentPoll ? `flex: 1` : ``)};
    flex-direction: column;
    margin: 15px 0 10px 0;
    font-size: 18px;
    ${props =>
        widthEm() <= 30
            ? `
        margin-top: 1em;
        ${
            props.isContactAction && !props.useLocalRepresentative
                ? `flex-direction: column;`
                : ``
        }
      `
            : ``};
`;

export const DetailsContainer = styled.div`
    margin-top: 10px;
    display: flex;
    flex: 1;
    flex-direction: row;
    ${props => (props.isVideoCard ? `` : `align-items: center`)};
    ${props => (props.isVideoCard ? `justify-content: center` : ``)};
    ${() => (isPortrait() ? `flex-direction: column;` : ``)};
`;

export const Details = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    ${props => (props.hasPhoto && !isPortrait() ? `margin-left: 1em;` : '')};
    ${() => (isPortrait() ? `align-self: flex-start;` : ``)};
`;

export const Footer = styled.footer`
    display: flex;
    width: 100%;
    height: 40px;
    justify-content: space-between;
    align-self: flex-end;
`;



// WEBPACK FOOTER //
// ./src/containers/DefaultStyles/Shared.jsx